import UserTag from "./userTag";
import UserTagMappingType from "./userTagMappingType";

export default class UserTagMapping {
  public idUserTagMapping: number = 0;
  public idUserTag: number = 0;
  public userTagMappingType: UserTagMappingType =
    UserTagMappingType.InvitationTag;
  public userTag: UserTag = new UserTag();
}
